export const fullContent =
  'A personalized plan that will guide you through the entire job search process from creating and optimizing a resume to passing an interview and accepting an offer'

export const shortContent =
  'Partner with a coach to customize a successful strategy for a new role with confidence and daily achievements.'

export const jobSearchUrl = '/app/career-plans/execute-a-job-search'
